import { render, staticRenderFns } from "./ConnectSFOX.vue?vue&type=template&id=c7604330&"
import script from "./ConnectSFOX.vue?vue&type=script&lang=js&"
export * from "./ConnectSFOX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports